import React from 'react'
import Adminuser from '../Component/Adminuser'

const User = () => {
  return (
    <>
    <Adminuser />
    </>
  )
}

export default User
